export default __webpack_public_path__ + "static/media/67.86e09ff8.jpg";